import { colors, DynamicForm } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const EmployeeFormWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding-bottom: 1rem;
`;

export const DynamicFormStyled = styled(DynamicForm)`
  min-height: 25rem;
`;
